export default {
    /**
     * @description 配置显示在浏览器标签的title
     */
    title: '宁波科蓝中水信息技术有限公司',

    /** 公司名称 */
    name: '宁波科蓝中水信息技术有限公司',
    /** 公司微信 */
    wechat: '',
    /** 公司邮箱 */
    email: '',
    /** 公司手机 */
    phone: '0574-87771850',
    /** icp备案号 */
    ICP: '浙ICP备2024086337号',
    /** 公网安备案*/
    polic: '',
    /** 公司电话 */
    tel: '0574-87771850',
    /** 公司地址 */
    address: '浙江省宁波市鄞州区新梅路AUX奥创中心A幢205',
    /** 备案号 */
    keepOnRecordIcp: '浙ICP备2024086337号-1',
    nowDate: new Date().getFullYear(),
    /** 百度地图相关信息 */
    BDMapInfo: {
        longitude: 121.662092,
        latitude: 29.888078,
        title: '宁波科蓝中水信息技术有限公司',
        address: '浙江省宁波市鄞州区新梅路AUX奥创中心A幢205'
    }
}



// WEBPACK FOOTER //
// ./src/config/index.js